module.exports = __webpack_public_path__ + "static/logo-853cadd6b56e9148dd9e245f15533fb8.svg";